import { FCM_SEARCH_V2_MAINTENANCE } from '@change-corgi/fcm/configs';

import { createFcmContext } from 'src/app/shared/contexts/fcm';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmContext: SearchPageFcmContext,
	FcmProvider: SearchPageFcmContextProvider,
	useFcm: useSearchPageFcm,
	useAsyncFcm: useAsyncSearchPageFcm,
	prefetchFcm: prefetchSearchPageFcm,
} = createFcmContext({
	name: 'SearchPageFcmContext',
	dataProperty: 'pageFcm',
	configs: {
		isUnderMaintenance: FCM_SEARCH_V2_MAINTENANCE,
	},
	prefetch: true,
});

export type SearchPageFcmState = ReturnType<typeof useAsyncSearchPageFcm>;
export type SearchPageFcm = LoadedStateData<SearchPageFcmState>;
